/**
 * UUID.js
 *
 * This is a plugin to expose a universal id for each vue component
 *
 */

let uuid = 0;

export default {
    install(Vue) {
        Vue.mixin({
            beforeCreate() {
                this.uuid = uuid.toString();
                uuid += 1;
            },
        });
    },
};
